import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Deposit.css";

const API_BASE = import.meta.env.VITE_API_BASE || "https://primerise.space";
const MIN_DEPOSIT = 50;
const MAIN_DEPOSIT_ADDRESS = "TLqt92MeTo47ZBDNto1w5eFNEYQi3oakTt";

const getStoredToken = () =>
  localStorage.getItem("token") ||
  localStorage.getItem("primeriseToken") ||
  localStorage.getItem("naxoraToken") ||
  localStorage.getItem("authToken") ||
  "";

const readJsonSafely = async (response) => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

const Deposit = () => {
  const [amount, setAmount] = useState("");
  const [txid, setTxid] = useState("");
  const [copied, setCopied] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const validateForm = () => {
    const numericAmount = Number(amount);

    if (!amount || Number.isNaN(numericAmount)) {
      return "Please enter a valid amount.";
    }

    if (numericAmount < MIN_DEPOSIT) {
      return `Minimum deposit is ${MIN_DEPOSIT}$.`;
    }

    if (!txid.trim()) {
      return "Transaction hash is required.";
    }

    if (txid.trim().length < 10) {
      return "Please enter a valid transaction hash.";
    }

    return "";
  };

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(MAIN_DEPOSIT_ADDRESS);
      setCopied(true);
      setMessage({
        type: "success",
        text: "Wallet address copied successfully.",
      });
      setTimeout(() => setCopied(false), 1800);
    } catch {
      setMessage({
        type: "error",
        text: "Unable to copy address.",
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage({ type: "", text: "" });

    const validationError = validateForm();

    if (validationError) {
      setMessage({ type: "error", text: validationError });
      return;
    }

    const token = getStoredToken();

    if (!token) {
      setMessage({ type: "error", text: "Please login first." });
      return;
    }

    const payload = {
      amount: Number(amount),
      method: "USDT TRC20",
      transactionId: txid.trim(),
      note: `Wallet: ${MAIN_DEPOSIT_ADDRESS}`,
    };

    setSubmitting(true);

    try {
      const response = await fetch(`${API_BASE}/api/deposits/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await readJsonSafely(response);

      if (!response.ok) {
        setMessage({
          type: "error",
          text: data?.message || "Deposit submission failed.",
        });
        return;
      }

      setMessage({
        type: "success",
        text: data?.message || "Deposit submitted successfully.",
      });

      setAmount("");
      setTxid("");
    } catch (error) {
      console.error("Deposit submit error:", error);
      setMessage({
        type: "error",
        text: "Something went wrong while submitting the deposit.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="deposit-page">
      <div className="deposit-shell">
        <div className="deposit-topbar">
          <Link to="/dashboard" className="deposit-back-btn">
            ← Back
          </Link>
        </div>

        <div className="deposit-hero-card">
          <h1 className="deposit-title">Deposit</h1>
          <p className="deposit-subtitle">Minimum {MIN_DEPOSIT}$</p>
        </div>

        <div className="deposit-grid">
          <div className="deposit-wallet-card">
            <div className="deposit-card-head">
              <span>USDT TRC20 Wallet</span>
            </div>

            <div className="deposit-address-box">
              <p className="deposit-address-text">{MAIN_DEPOSIT_ADDRESS}</p>
            </div>

            <button
              type="button"
              className="deposit-copy-btn"
              onClick={handleCopyAddress}
            >
              {copied ? "Copied" : "Copy Address"}
            </button>
          </div>

          <div className="deposit-form-card">
            <form onSubmit={handleSubmit} className="deposit-form">
              <input
                type="number"
                placeholder={`Minimum ${MIN_DEPOSIT}`}
                min={MIN_DEPOSIT}
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />

              <input
                type="text"
                placeholder="Enter TXID / Transaction Hash"
                value={txid}
                onChange={(e) => setTxid(e.target.value)}
              />

              {message.text ? (
                <div className={`deposit-message ${message.type}`}>
                  {message.text}
                </div>
              ) : null}

              <button
                type="submit"
                className="deposit-submit-btn"
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit Deposit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deposit;